import React from "react";
import { Link as RouterLink } from "react-router-dom";
import { Header, BrandLockup, TextInput, Tooltip } from "components";
import GroupardyAuthUserButton from "features/auth/GroupardyAuthUserButton";
import "./ManagerHeader.css";

/**
 * The manager app's top bar. Wraps the shared <Header /> primitive and bakes in
 * the parts every manager surface shares — the Groupardy brand lockup (mark +
 * wordmark, linking back to /manage) and the Clerk account button — so the
 * dashboard and the per-game shell don't each re-compose them.
 *
 * Slots:
 *   search:      bool — render the "coming soon" search field in the lead slot
 *                (dashboard). Mutually exclusive with breadcrumbs.
 *   breadcrumbs: node — breadcrumb trail in the lead slot (per-game shell).
 *   status:      node — e.g. a <StatusPill /> (right cluster, before actions/cta).
 *   actions:     node — secondary controls (e.g. a Help button), right cluster.
 *   cta:         node — primary action (New Game / state SplitButton), rightmost
 *                before the avatar.
 */
const SearchGlyph = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor"
    strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <circle cx="11" cy="11" r="7" />
    <line x1="21" y1="21" x2="16.65" y2="16.65" />
  </svg>
);

const ManagerHeader = ({ search = false, breadcrumbs, status, actions, cta }) => {
  let lead = null;
  if (search) {
    lead = (
      <Tooltip title="Search across your games — coming soon">
        <span className="gx-mhdr-search">
          <TextInput
            leftIcon={<SearchGlyph />}
            placeholder="Search games, categories, clues…"
            readOnly
            aria-label="Search (coming soon)"
          />
        </span>
      </Tooltip>
    );
  } else if (breadcrumbs) {
    lead = <div className="gx-mhdr-lead">{breadcrumbs}</div>;
  }

  const right = status || actions || cta;

  return (
    <Header
      brand={
        <RouterLink to="/manage" className="gx-mhdr-brand" aria-label="Groupardy — My Games">
          <BrandLockup size="sm" variant="light" />
        </RouterLink>
      }
      search={lead}
      actions={
        right ? (
          <div className="gx-mhdr-right">
            {status}
            {actions}
            {cta}
          </div>
        ) : undefined
      }
      trailing={<GroupardyAuthUserButton />}
    />
  );
};

export default ManagerHeader;
